import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layout Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Section Components
import Hero from './components/sections/Hero';
import BrandAuthority from './components/sections/BrandAuthority';
import About from './components/sections/About';
import AudienceInsights from './components/sections/AudienceInsights';
import PerformanceMetrics from './components/sections/PerformanceMetrics';
import ContentShowcase from './components/sections/ContentShowcase';
import CaseStudies from './components/sections/CaseStudies';
import Services from './components/sections/Services';
import Testimonials from './components/sections/Testimonials';
import FinalCTA from './components/sections/FinalCTA';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <main>
        <Hero />
        <BrandAuthority />
        <About />
        <AudienceInsights />
        <PerformanceMetrics />
        <ContentShowcase />
        <CaseStudies />
        <Services />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
